import React, {useId, useRef, useState} from 'react';

/** Substantial help opens explicitly; pointer travel and focus never move content. */
export default function AttentionDisclosure({label, children}: React.PropsWithChildren<{label: string}>) {
 const [open, setOpen] = useState(false);
 const id = useId();
 const trigger = useRef<HTMLButtonElement>(null);
 return <div className="pp-attention-disclosure"
  onKeyDown={e => {if (e.key === 'Escape' && open) {e.preventDefault();e.stopPropagation();setOpen(false);trigger.current?.focus();}}}>
  <button ref={trigger} type="button" className="pp-attention-trigger" aria-expanded={open} aria-controls={id} onClick={() => setOpen(v=>!v)}>
   {label}<span aria-hidden="true">{open ? '−' : '+'}</span>
  </button>
  <div id={id} className="pp-attention-content" hidden={!open}>{children}</div>
 </div>;
}
